import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import AppBar from '@mui/material/AppBar';
import CssBaseline from '@mui/material/CssBaseline';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { useMediaQuery } from "@mui/material";
import { Link } from "react-router-dom";
import DrawerComponent from './Drawer';
import { Outlet } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import { useTheme } from '@mui/material/styles';
// redux
import { useSelector, useDispatch } from 'react-redux';
// import logo from '@images/logo-tns.png'
import logo from '@images/logo_white.png'
import useStyles from "@hooks/useStyles";
import CommonDrawer from '@components/CommonDrawer';
import {siteTitle} from '@util/string'
import { customerMenu } from '@util/menu';
const defSx = {color:'#212121', fontSize:20}
const drawerWidth = 240;
const mainColor = '#33c058'
export default function CustomerDrawer() {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  // redux
  const codeGroups = useSelector(state => state.codeGroupReducer)
  const codes = useSelector(state => state.codeReducer)
  const schools = useSelector(state => state.schoolReducer)
  const account = useSelector(state => state.accountReducer)
  const schola = useSelector(state => state.scholaReducer)

  const sideMenu = [
    {
      title: '고객센터',
      list: customerMenu.map(item => {
         const d ={id: item.id, text:item.label,   to:item.to, visible: true, icon:<LabelOutlinedIcon size='small' sx={defSx}/> }
         return d
       }),
    },
  ]

  // const sideMenu = [
  //   {text:'업무시간',   to:'/customer/worktime', visible: true, icon:<LabelOutlinedIcon size='small' sx={defSx}/> },
  //   {text:'배송 및 처리시간',   to:'/customer/process', visible: true, icon:<LabelOutlinedIcon  size='small' sx={defSx}/> },
  //   {text:'요금&환급',      to:'/customer/fee', visible: true, icon:<LabelOutlinedIcon  size='small' sx={defSx}/> },
  //   {text:'공지사항',   to:'/customer/gongji', visible: true, icon:<LabelOutlinedIcon  size='small' sx={defSx}/>},
  //   {text:'이용약관/개인정보처리방침',   to:'/customer/terms', visible: true, icon:<LabelOutlinedIcon  size='small' sx={defSx}/>},
  //   {text:'divider', visible: true},
  // ]

  return (
    <CommonDrawer sideMenu={sideMenu} showSideEveryScreen={true} title={siteTitle} barBgColor={'#fff'}/>
  );
}
